import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programa-universidad-excel'), {
      params: opciones.params,
      responseType: 'arraybuffer',
    });
  },
  async inscritosSolicitudesPagosConsolidadosRaw(opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos('programa-universidad-excel/inscritos-solicitudes-pagos-consolidados-raw'),
      {
        params: opciones.params,
        responseType: 'arraybuffer',
      },
    );
  },
};
